<div>
    <div id="chart-container mb-3">
        <div id="chart-line"></div>
    </div>

    <div class="row mt-4">
        <div class="col-6 mb-2" *ngFor="let data of statusData">
            <div class="status-chart d-flex align-items-center">
                <div class="d-flex justify-content-between w-100" >
                    <div class="d-flex justify-content-start align-items-center" style="width: 90%;" >
                        <div [ngStyle]="{'background-color': data.color}" class="circle-status"></div>
                        <span>{{data.status}}</span>
                    </div>
                    <span>{{data.total}}</span>
                </div>
                 
            </div>
            
        </div>
    </div>
</div>